import React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { Stack, Typography, useTheme } from "@mui/material";

const PieChartt = ({ validRows }) => {
  const theme = useTheme();

  // Initialize status counts
  const statusCounts = {
    New: 0,
    Failed: 0,
    Completed: 0,
    Busy: 0,
    Done: 0,
    "Re-Evaluation Requested": 0,
  };

  // Count occurrences of each status
  validRows.forEach((row) => {
    if (statusCounts[row.status] !== undefined) {
      statusCounts[row.status] += 1;
    }
  });

  const Status = [
    {
      label: "New",
      value: statusCounts.New,
      color: theme.palette.primary.main,
    },
    {
      label: "Failed",
      value: statusCounts.Failed,
      color: theme.palette.error.main,
    },
    {
      label: "Completed",
      value: statusCounts.Completed,
      color: theme.palette.secondary.main,
    },
    {
      label: "Busy",
      value: statusCounts.Busy,
      color: theme.palette.warning.main,
    },
    {
      label: "Done",
      value: statusCounts.Done,
      color: theme.palette.success.main,
    },
    {
      label: "Dispute Requested",
      value: statusCounts["Dispute Requested"],
      color: theme.palette.error.main,
    },
    {
      label: "Re-Evaluation Requested",
      value: statusCounts["Re-Evaluation Requested"],
      color: theme.palette.primary.main,
    },
  ];

  // Normalize function if needed for specific percentage adjustments
  const normalize = (v, v2) => Number.parseFloat((v * v2).toFixed(2));

  const data = [
    ...Status.map((v) => ({
      ...v,
      label: v.label,
      value: normalize(v.value, 1),
    })),
  ];

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%" }}>
      <PieChart
        series={[
          {
            data: data,
            arcLabel: (item) => `${item.label}: ${item.value}`,
            arcLabelMinAngle: 35,
            arcLabelRadius: "60%",
            highlightScope: { fade: "global", highlight: "item" },
            // faded: { innerRadius: 30, additionalRadius: -40, color: "gray" },
            innerRadius: 30,
            outerRadius: 100,
            paddingAngle: 5,
            cornerRadius: 5,
          },
        ]}
        height={250}
        width={250}
        slotProps={{ legend: { hidden: true } }}
      />

      {/* Custom Legend */}
      <Stack>
        {Status.map((status) => (
          <div
            key={status.label}
            style={{
              display: "flex",
              alignItems: "center",
            }}>
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: status.color,
                marginRight: "5px",
              }}></div>
            <Typography variant="caption">{status.label}</Typography>
          </div>
        ))}
      </Stack>
    </Stack>
  );
};

export default PieChartt;
